import {getBranchLocator} from '../../../../../rest/locators'
import {stringifyId} from '../../../../../types'
import type {BuildId} from '../../../../../types'

import type {LastDeployedBuildConfig} from './Deployments.types'

export const deployLocator = 'type:deployment,project(archived:false)'
export const getDeploymentsLocator = (buildId: BuildId): string =>
  `buildType(${deployLocator}),` +
  `item(defaultFilter:false,snapshotDependency(from:(id:${stringifyId(buildId)}))),` +
  `item(defaultFilter:false,artifactDependency(from:(id:${stringifyId(buildId)}),recursive:false))`

export function getLastDeployedBuildLocator({
  buildTypeId,
  branch,
  deployTypeId,
}: LastDeployedBuildConfig): string {
  const deploymentLocator = [
    'defaultFilter:false',
    `buildType:(id:${stringifyId(deployTypeId)})`,
    getBranchLocator(branch),
  ]
    .filter(Boolean)
    .join(',')
  return (
    `count:1,defaultFilter:false,buildType:(id:${stringifyId(buildTypeId)}),` +
    `item(snapshotDependency:(to:(${deploymentLocator}))),` +
    `item(artifactDependency:(to:(${deploymentLocator}),recursive:false))`
  )
}
